import { Clipboard, RefreshCcw, Send } from "lucide-react";
import type { Hsb, RoundColor } from "../color";
import { hsbToHex, MAX_TOTAL, scoreLabel, totalLabel } from "../color";
import { copy } from "../copy";

export type RoundResult = {
  target: RoundColor;
  guess: Hsb;
  score: number;
  distance: number;
};

export function Results({ results, total, best, onShare, onCopy, onRestart }: {
  results: RoundResult[];
  total: number;
  best: number;
  onShare: () => void;
  onCopy: () => void;
  onRestart: () => void;
}) {
  return (
    <article className="stage results" aria-label="최종 결과">
      <div className="prompt">
        <b>{copy.finalLabel}</b>
        <span>
          {totalLabel(total)} · {copy.bestScore} {best}
        </span>
      </div>
      <div className="results-total">
        <strong>{total}</strong>
        <small>/{MAX_TOTAL}</small>
      </div>
      <ol className="results-list">
        {results.map((item, index) => (
          <li key={index}>
            <span className="results-index">{index + 1}</span>
            <div className="results-pair">
              <i style={{ background: item.target.hex }} aria-label={copy.target} />
              <i style={{ background: hsbToHex(item.guess) }} aria-label={copy.guess} />
            </div>
            <div className="results-meta">
              <strong>{item.score}점</strong>
              <small>{scoreLabel(item.score)}</small>
            </div>
          </li>
        ))}
      </ol>
      <div className="actions">
        <button className="primary" onClick={onShare}>
          <Send size={18} />
          {copy.share}
        </button>
        <button onClick={onCopy}>
          <Clipboard size={18} />
          {copy.copyResult}
        </button>
        <button onClick={onRestart}>
          <RefreshCcw size={18} />
          {copy.newGame}
        </button>
      </div>
    </article>
  );
}
